interface TargetingOverlayProps {
  cursorPos: { x: number; y: number };
  onCancel: () => void;
}

export function TargetingOverlay({ cursorPos, onCancel }: TargetingOverlayProps) {
  return (
    <>
      <div className="fixed inset-0 z-[9998] cursor-crosshair targeting-ui">
        <div
          className="pointer-events-none fixed"
          style={{ transform: `translate(${cursorPos.x - 16}px, ${cursorPos.y - 16}px)` }}
        >
          <svg width="32" height="32" viewBox="0 0 32 32">
            <circle cx="16" cy="16" r="2" fill="rgb(59, 130, 246)" />
            <line x1="16" y1="4" x2="16" y2="12" stroke="rgb(59, 130, 246)" strokeWidth="1.5" />
            <line x1="16" y1="20" x2="16" y2="28" stroke="rgb(59, 130, 246)" strokeWidth="1.5" />
            <line x1="4" y1="16" x2="12" y2="16" stroke="rgb(59, 130, 246)" strokeWidth="1.5" />
            <line x1="20" y1="16" x2="28" y2="16" stroke="rgb(59, 130, 246)" strokeWidth="1.5" />
          </svg>
        </div>

        <div className="fixed top-4 left-1/2 -translate-x-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg shadow-lg text-sm targeting-ui">
          <div className="font-semibold text-xs tracking-wider mb-0.5">ELEMENT TARGETING</div>
          <div className="text-gray-300">Hover to highlight, click to select, ESC to cancel</div>
        </div>
      </div>

      <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5 rounded-full text-xs font-semibold shadow-lg targeting-ui">
        <div className="w-2 h-2 rounded-full bg-white animate-pulse" />
        <span>TARGETING</span>
        <button
          onClick={onCancel}
          className="ml-1 px-1.5 py-0.5 bg-white/20 rounded text-[10px] hover:bg-white/30"
        >
          ESC
        </button>
      </div>
    </>
  );
}
